import CenterFocusStrongIcon from "@mui/icons-material/CenterFocusStrong";
import { Button } from "@mui/material";
import { Map } from "ol";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { PortMapItem } from "../types/mapItems";
import { GenericPopup } from "./GenericPopup";

type Props = {
  data: PortMapItem;
  map: Map;
};

export const PortPopup = ({ data, map }: Props): JSX.Element => {
  const { t } = useTranslation("port");
  const history = useHistory();
  const { name, description, locode } = data;

  const handleClick = () => {
    const ol = map?.getOverlayById("popup");
    ol?.setPosition(undefined);
    ol?.set("clickedOpen", false);
    const params = new URLSearchParams(history.location.search);
    params.delete("port");
    params.append("port", data.id.toString());
    history.push({
      pathname: history.location.pathname,
      search: params.toString(),
    });
  };

  return (
    <GenericPopup
      map={map}
      clicked
      avatarText={name[0]}
      title={`${name} - ${locode?.locode ?? ""}`}
      subheader={description ?? ""}
      content={
        <Button
          variant="contained"
          color="secondary"
          endIcon={<CenterFocusStrongIcon />}
          onClick={handleClick}
        >
          {t("focus")}
        </Button>
      }
    />
  );
};
